class DeleteRvqImmunizationRequest {
    public ImmunizationId: number;
    public Version: string;
    public DeletionReason: string;
    public DeletionReasonComment: string;
    public TransactionId: string;

    public constructor(fields?: Partial<DeleteRvqImmunizationRequest>) {
        Object.assign(this, fields);
    }
}

export { DeleteRvqImmunizationRequest };
